/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo, useState } from "react";
import { Form, InputNumber, Input, Popconfirm } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { disabledTransactionText, formatPrice, loanTypeData } from "../../Common/commondata/commonData";
import { useSelector } from "react-redux";
const { TextArea } = Input;

function CustomInputField({ docId, save, keyName, ele, placeholder, formatCol, acceptint, source, markedAsHidden }) {
  const { URLofferTableJSON, checkForDisable } = useSelector((s) => s?.offerTable);

  const [formattedValue, setFormattedValue] = useState(source === "Editable" ? ele?.data?.[keyName] ?? "" : "");
  const [previousTextValue, setPreviousTextValue] = useState(source === "Editable" ? ele?.data?.[keyName] ?? "" : "");
  const [showInput, setShowInput] = useState(false);

  // Normalize helper
  const normalize = (val, { isPrice = false } = {}) => {
    if (val === null || val === undefined) return "";
    let s = String(val);
    if (isPrice) {
      // remove $ sign, commas, spaces
      s = s.replace(/[\s,$]/g, "");
    }
    return s.trim();
  };

  const isPriceField = formatCol === "text" && acceptint === true;

  // compute normalized values and hasChanged
  const { hasChanged } = useMemo(() => {
    const currentRaw = isPriceField ? formattedValue : previousTextValue;
    const oldRaw = ele?.data?.[keyName];
    const currentNorm = normalize(currentRaw, { isPrice: isPriceField });
    const oldNorm = normalize(oldRaw, { isPrice: isPriceField });

    return { oldNormalized: oldNorm, hasChanged: currentNorm !== oldNorm };
  }, [formattedValue, previousTextValue, ele?.data?.[keyName], keyName, isPriceField]);

  const formatValueToUSD = (value) => {
    if (value === "" || value === null || value === undefined) {
      setFormattedValue("");
      return;
    }
    const formatted = formatPrice({ price: value, source: "CUSTOM_INPUT_FIELD" });
    if (formatted) {
      setFormattedValue(`$ ${formatted}`);
    } else {
      setFormattedValue(String(value));
    }
  };

  return (
    <Form.Item style={{ margin: 0 }}>
      <Popconfirm
        title="Update ?"
        {...(checkForDisable?.disabled
          ? { onConfirm: disabledTransactionText }
          : {
              onConfirm: () => {
                if (hasChanged) {
                  const valueToSend = isPriceField ? formattedValue : previousTextValue;
                  save(keyName, ele, valueToSend);
                } else {
                  console.log("No changes detected → skipping API call");
                }
              },
            })}
        okText="Yes"
        cancelText="No"
        okButtonProps={checkForDisable?.disabled ? {} : { disabled: !hasChanged }}
        {...(checkForDisable?.disabled
          ? {}
          : {
              onCancel: () => {
                // restore original values
                const original = ele?.data?.[keyName] ?? "";
                if (isPriceField) {
                  // if original is numeric, you may want formatted display
                  if (original === "" || original === null || original === undefined) {
                    setFormattedValue("");
                  } else {
                    const formatted = formatPrice({ price: original, source: "CUSTOM_INPUT_FIELD" });
                    setFormattedValue(formatted ? `$ ${formatted}` : String(original));
                  }
                } else {
                  setPreviousTextValue(original);
                }
              },
            })}
      >
        {isPriceField ? (
          source === "Editable" && !showInput ? (
            <>
              <span style={{ color: markedAsHidden ? "gray" : "black", fontSize: 18 }}>{formatPrice({ price: ele?.data?.[keyName], source: "CUSTOM_INPUT_FIELD" }) ? `$ ${formatPrice({ price: ele?.data?.[keyName], source: "CUSTOM_INPUT_FIELD" })}` : "N/A"}</span>
              <span style={{ marginLeft: 25 }}>
                <EditOutlined
                  style={{
                    color: "hsl(211deg 77% 48%)",
                    pointerEvents: URLofferTableJSON?.urlData?.sellerOpenOfferTable || checkForDisable?.disabled ? "none" : "auto",
                    fontSize: 16,
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowInput(!showInput);
                  }}
                />
              </span>
            </>
          ) : (
            <InputNumber
              id={docId}
              style={{ width: "100%", pointerEvents: URLofferTableJSON?.urlData?.sellerOpenOfferTable || checkForDisable?.disabled ? "none" : "auto" }}
              // value should be numeric or empty string
              value={(() => {
                const v = formattedValue;
                if (v === "" || v === null || v === undefined) return "";
                // if it already contains '$', stripping and parsing it to number
                const n = normalize(v, { isPrice: true });
                return n === "" ? "" : Number(n);
              })()}
              onChange={(val) => {
                setFormattedValue(val === null ? "" : val);
              }}
              onBlur={(e) => formatValueToUSD(e.target.value)}
              placeholder={placeholder}
              // built-in formatting:
              formatter={(num) => (num === "" || num === null || num === undefined ? "" : `$ ${String(num).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`)}
              parser={(str) => String(str)?.replace(/\$\s?|(,*)/g, "")}
            />
          )
        ) : formatCol === "loanType" ? (
          <select id={docId} style={{ width: "100%" /* styles omitted for brevity */ }}>
            {loanTypeData &&
              loanTypeData.map((lt, idx) => (
                <option key={idx} disabled={URLofferTableJSON?.urlData?.sellerOpenOfferTable || checkForDisable?.disabled} value={lt}>
                  {lt}
                </option>
              ))}
          </select>
        ) : (
          <TextArea rows={4} id={docId} value={previousTextValue} onChange={(e) => setPreviousTextValue(e.target.value)} style={{ pointerEvents: URLofferTableJSON?.urlData?.sellerOpenOfferTable || checkForDisable?.disabled ? "none" : "auto" }} placeholder={placeholder} />
        )}
      </Popconfirm>
    </Form.Item>
  );
}

export { CustomInputField };
